
import RcDomainObject from "../../../common/RcDomainObject.js";
import Company from "../../company/Company.js";
import User from "../../user/User.js";
import EmployeePreferencesMap from "./EmployeePreferencesMap.js";
import StringUtils from "@/utils/StringUtils";

export default class EmployeePreferences extends RcDomainObject {

  static MODEL_NAME = "EmployeePreferences";
  
  static Fields = {
    USER : "User",
    COMPANY : "Company",
    STATE: 'state',
    TIMESHEET_STARTED_BEFORE_INSPECTION: 'timesheetStartedBeforeInspection',
    INSPECTION_EMAILED_TO_DRIVER: 'inspectionEmailedToEmployee',
    DRIVER_CAN_UPDATE_PROFILE: 'driverCanUpdateProfile'
  }
   
  static Values = {
    YES : 'yes',
    NO : 'no',
    GLOBAL : 'global'
  }

  constructor(domain, data) {
    super(domain, data, EmployeePreferences.MODEL_NAME);
  }

  fields() {
    return EmployeePreferences.Fields;
  }

  find() {
    return this.domain.employees().preferences().findById(this.id());
  }
  
  user() {
    return new User(this.domain, this.get(EmployeePreferences.Fields.USER));
  }
  
  withUser(user) {
    this.put(EmployeePreferences.Fields.USER, user);
    return this;
  }
  
  state() {
    return this.getString(EmployeePreferences.Fields.STATE);
  }
  
  company() {
    var companyData = this.data[EmployeePreferences.Fields.COMPANY];
    return new Company(this.domain, companyData);
  }
  
  withCompany(company) {
    this.put(EmployeePreferences.Fields.COMPANY, company);
    return this;
  }
  
  timesheetStartedBeforeInspection() {
    return this.getString(EmployeePreferences.Fields.TIMESHEET_STARTED_BEFORE_INSPECTION);
  }

  withTimesheetStartedBeforeInspection(value) {
    this.put(EmployeePreferences.Fields.TIMESHEET_STARTED_BEFORE_INSPECTION, value);
    return this;
  }

  timesheetStartedBeforeInspectionDisplay() {
    let value = this.timesheetStartedBeforeInspection();
    if (StringUtils.isEmpty(value)) {
      value = EmployeePreferences.Values.GLOBAL;
    }
    return value;
  }
  
  emailInspectionsToDriver() {
    return this.getString(EmployeePreferences.Fields.INSPECTION_EMAILED_TO_DRIVER);
  }

  withEmailInspectionsToDriver(value) {
    this.put(EmployeePreferences.Fields.INSPECTION_EMAILED_TO_DRIVER, value);
    return this;
  }

  emailInspectionsToDriverDisplay() {
    let value = this.emailInspectionsToDriver();
    if (StringUtils.isEmpty(value)) {
      value = EmployeePreferences.Values.GLOBAL;
    }
    return value;
  }

  driverCanUpdateProfile() {
    return this.getString(EmployeePreferences.Fields.DRIVER_CAN_UPDATE_PROFILE);
  }

  withDriverCanUpdateProfile(value) {
    this.put(EmployeePreferences.Fields.DRIVER_CAN_UPDATE_PROFILE, value);
    return this;
  }

  driverCanUpdateProfileDisplay() {
    let value = this.driverCanUpdateProfile();
    if (StringUtils.isEmpty(value)) {
      value = EmployeePreferences.Values.GLOBAL;
    }
    return value;
  }

  map() {
    var map = new EmployeePreferencesMap(this.domain);
    map.add(this);
    return map;
  }

  modifiedBy() {
    return new User(this.domain, this.get(EmployeePreferences.DefaultFields.MODIFIED_BY));
  }

  createdBy() {
    return new User(this.domain, this.get(EmployeePreferences.DefaultFields.CREATED_BY));
  }

}